<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title" v-if="!emailSent">
        <img src="../assets/logo.png"/>
        <div class="md-body-1">Create meaningful culture, experiences, connections.</div>
      </div>
      <div class="title" v-if="emailSent">
        <md-icon class="md-size-5x">email</md-icon>
        <div class="md-title">Check your email</div>
        <div class="md-body-1">We sent an email to you at {{login.email}}. It has a magic link that'll log you in.</div>
      </div>
      <div class="form" v-if="!emailSent">
        <md-field :class="getValidationClass('email')">
          <label>Email</label>
          <md-input name="email" id="email" autocomplete="email" v-model="login.email" @keyup.native.enter="next"/>
          <span class="md-error" v-if="!$v.login.email.required">The email is required</span>
          <span class="md-error" v-else-if="!$v.login.email.email">Invalid email</span>
          <span class="md-error" v-else-if="this.no_account">User Account does not exist.</span>
        </md-field>
      </div>
      <div class="actions md-layout" v-if="!emailSent">
        <md-button class="md-raised md-primary" @click="next">Next</md-button>
      </div>
    </md-content>
    <div class="background"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import * as types from '../store/event_types'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
} from 'vuelidate/lib/validators'
export default {
  name: "Login",
  mixins: [validationMixin],
  computed: {
    ...mapState({
      'no_account': s => s.auth.no_account
    }),
    emailSent() {
      return this.$store.state.auth.link_sent
    }
  },
  validations: {
    login: {
      email: {
        required,
        email
      }
    }
  },
  data() {
    return {
      login: {
        email: ""
      }
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.login[fieldName]

      if (field) {
        return {
          'md-invalid': (field.$invalid && field.$dirty) || (fieldName == 'email' && this.no_account)
        }
      }
    },
    next(){
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$store.dispatch(types.DETERMINE_LOGIN, { 'email': this.login.email, 'state': this.$route.query.state})
      }
    }
  }
}
</script>

<style lang="scss">
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  .title {
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 16px;
      max-width: 160px;
    }
  }
  .actions {
    .md-button {
      margin: 0;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .background {
    background: rgb(2,0,36);
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 25%, rgba(0,212,255,1) 100%);
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
  }
  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
  }
  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
